import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import './EmailVerification.css';

const EmailVerification = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    verifyEmail();
  }, [token]);

  const verifyEmail = async () => {
    try {
      const response = await api.post('/auth/verify-email', { token });
      
      if (response.data.success) {
        setStatus('success');
        setMessage(response.data.message);
        setEmail(response.data.user?.email || '');
        
        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.message || 'Failed to verify email. The link may have expired.');
    }
  };

  const resendVerification = async () => {
    try {
      setStatus('verifying');
      const response = await api.post('/auth/send-verification-email');
      
      if (response.data.success) {
        setStatus('success');
        setMessage('Verification email sent! Please check your inbox.');
      }
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.message || 'Failed to resend verification email.');
    }
  };

  return (
    <div className="email-verification-container">
      <div className="verification-card">
        {status === 'verifying' && (
          <>
            <div className="verification-icon verifying">
              <div className="spinner"></div>
            </div>
            <h1>Verifying Your Email...</h1>
            <p>Please wait while we verify your email address.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="verification-icon success">
              <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                <circle cx="40" cy="40" r="40" fill="#10b981" />
                <path d="M25 40L35 50L55 30" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h1>✅ Email Verified!</h1>
            <p>{message}</p>
            {email && <p className="email-display">📧 {email}</p>}
            <p className="redirect-message">Redirecting to login page in 3 seconds...</p>
            <button className="btn-primary" onClick={() => navigate('/login')}>
              Go to Login Now
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="verification-icon error">
              <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                <circle cx="40" cy="40" r="40" fill="#ef4444" />
                <path d="M30 30L50 50M50 30L30 50" stroke="white" strokeWidth="4" strokeLinecap="round" />
              </svg>
            </div>
            <h1>❌ Verification Failed</h1>
            <p>{message}</p>
            <div className="action-buttons">
              <button className="btn-primary" onClick={() => navigate('/login')}>
                Go to Login
              </button>
              <button className="btn-secondary" onClick={() => navigate('/register')}>
                Create New Account
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EmailVerification;
